import { Label } from "@/components/ui/label";

export const FormField = ({ id, label, error, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <Label htmlFor={id}>{label}</Label>
    {children}
    {error && <p className="text-xs text-red-600" data-testid={`${id}-error`}>{error}</p>}
  </div>
);

export const FormSection = ({ title, children }) => (
  <fieldset className="space-y-4">
    <legend className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#0F2D5E]">{title}</legend>
    {children}
  </fieldset>
);
